import { Component, OnInit } from '@angular/core';
import { AdalService } from 'adal-angular4';


// The main responsibility of this component is to handle the user's logout process.
// This is the starting point for the logout process, which is usually initiated when a
// user clicks on the logout button on the LoginMenu component.
@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.css']
})
export class LogoutComponent implements OnInit {

  constructor(private adalService: AdalService) { }

  async ngOnInit() { 
    }

  logMeout() {
       this.adalService.logOut();
   }

}

